<template >
    <div class="box" :style="{ height: videoHeight + 'px' }">
        <VideoPlayError v-if="showErorr" :liveText="errorInfor.liveText" :teacher="errorInfor.teacher"
            :time="errorInfor.time" :title="errorInfor.title" />
        <div v-else class="video">
            <video id="player-container-id" width="414" height="270" preload="auto" playsinline webkit-playsinline>
            </video>
        </div>
    </div>
</template>
<script>
import VideoPlayError from './VideoPlayError.vue';

export default {
    props: {
        src: "",
        errorInfor: Object,
        poster: {
            type: String,
            default: require('../../assets/images/live/playing/error_backround.png')
        },
        autoplay: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            videoHeight: 250, //视频高度
            showErorr: false,
            player: null
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.initLiveHieght();
            // player-container-id 为播放器容器 ID，必须与 html 中一致
            this.player = TCPlayer("player-container-id", {
                height: this.videoHeight,
                autoplay: this.autoplay,
                poster: this.poster
            });
            this.player.src(this.src); // url 播放地址
            this.player.on("error", (error) => {
                this.showErorr = true
            });
            this.player.ready(() => {
                if (this.autoplay) {
                    this.player.play()
                }
                this.initPlayButton()
            })
            this.player.on('play', () => {
                // 做一些处理
                if (!this.autoplay) {
                    this.$emit('videoStatus', true)
                }
            });

        })

    },
    beforeDestroy() {
        this.player.dispose()
    },
    methods: {
        pause() {
            this.player.pause()
        },
        getLiveHeight() {
            return window.screen.availWidth / 16 * 9;
        },
        initLiveHieght() {
            this.videoHeight = this.getLiveHeight() <= 500 ? this.getLiveHeight() : 500;
            //直接触发 子组件获取高度异常 所以延迟触发
            setTimeout(() => {
                this.$emit("onLoadVideoHeight", parseInt(this.videoHeight));
            });
        },
        initPlayButton() {
            setTimeout(() => {
                document.querySelector(".vjs-button-icon").innerHTML = `  
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
                            <g  transform="translate(-91.948 -98.949)">
                                <g transform="translate(91.948 98.949)">
                                    <circle  cx="19" cy="19" r="19" opacity="0.8" />
                                    <path 
                                        d="M418.2,319.108a1.384,1.384,0,0,0-2.2,1.12v14.695a1.384,1.384,0,0,0,2.2,1.118l10.1-7.347a1.384,1.384,0,0,0,0-2.239Z"
                                        transform="translate(-401.223 -308.489)" fill="#fff" />
                                </g>
                            </g>
                        </svg>
                    `
            })
        }
    },
    components: { VideoPlayError }
}
</script>
<style lang="scss" scoped>
.box {
    position: relative;
}

.video-js {
    width: 100%;
}

video {
    width: 100%;
}
</style>